var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_528_405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8557 21.8556C5.91554 21.2884 2.0791 17.0923 2.0791 12.0002C2.0791 6.52121 6.52072 2.07959 11.9997 2.07959C17.4788 2.07959 21.9204 6.52121 21.9204 12.0002C21.9204 17.1158 18.6637 16.6951 15.8822 16.3358C14.2779 16.1286 12.8317 15.9418 12.2595 16.8494C11.8682 17.4701 12.2912 18.2441 12.8101 18.7629C13.4583 19.4112 13.4583 20.4623 12.8101 21.1105C12.2912 21.6294 11.5846 21.9393 10.8557 21.8556ZM11.092 7.03966C11.092 7.86152 10.4258 8.52776 9.60391 8.52776C8.78205 8.52776 8.11581 7.86152 8.11581 7.03966C8.11581 6.21781 8.78205 5.55157 9.60391 5.55157C10.4258 5.55157 11.092 6.21781 11.092 7.03966ZM6.54339 12.9923C7.36524 12.9923 8.03148 12.326 8.03148 11.5042C8.03148 10.6823 7.36524 10.0161 6.54339 10.0161C5.72154 10.0161 5.05529 10.6823 5.05529 11.5042C5.05529 12.326 5.72154 12.9923 6.54339 12.9923ZM17.4561 12.9923C18.2779 12.9923 18.9442 12.326 18.9442 11.5042C18.9442 10.6823 18.2779 10.0161 17.4561 10.0161C16.6342 10.0161 15.968 10.6823 15.968 11.5042C15.968 12.326 16.6342 12.9923 17.4561 12.9923ZM14.4799 8.52799C15.3017 8.52799 15.968 7.86174 15.968 7.03989C15.968 6.21804 15.3017 5.5518 14.4799 5.5518C13.658 5.5518 12.9918 6.21804 12.9918 7.03989C12.9918 7.86174 13.658 8.52799 14.4799 8.52799Z",
    fill: "url(#paint0_linear_528_405)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_528_405",
    x: 0.0947266,
    y: -0.904785,
    width: 23.8096,
    height: 24.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_528_405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_528_405",
    x1: 2.97609,
    y1: 4.9396,
    x2: 24.049,
    y2: 8.22784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalleteIcon);
export default __webpack_public_path__ + "static/media/pallete-icon.fd4ed817b6c7c04c49b38086b7fe5ce5.svg";
export { ForwardRef as ReactComponent };